import { createAppSelector } from '@perxis-auto/instock-sdk/lib/shared/lib/store';
import { selectors as configSelectors } from '@perxis-auto/instock-sdk/lib/shared/store/config';

import { PAGES, PageType } from '@/shared/config/pages';

export const selectAvailablePages = createAppSelector(configSelectors.selectModels, modelsConfig => {
  return {
    [PAGES.Cars]: true,
    [PAGES.Car]: true,
    [PAGES.Models]: modelsConfig.enable,
    [PAGES.Comparison]: true,
    [PAGES.Favorites]: true,
    [PAGES[404]]: true,
    [PAGES[500]]: true,
  } satisfies Record<PageType, boolean>;
});
